import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import JsonExcel from "vue-json-excel";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.config.productionTip = false;
Vue.component("downloadExcel", JsonExcel);

new Vue({
  vuetify,
  render: h => h(App)
}).$mount("#app");
